import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import { Redirect } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import {
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  cleanAfiliadoSeleccionado,
  cleanPresupuestos,
  clearReducer,
  generateExcelConsultaPresupuesto,
  getBandejasPorUsuario,
  getContadoresPresupuestosGestion,
  getPresupuestosGestion,
  setEstadoPresupuestos,
} from "../../../actions/autorizaciones/Autorizaciones";
import { AutorizacionesBuscador } from "../Ingreso/AutorizacionesBuscador";
import {
  AREAS_USUARIOS,
  AUTORIZACIONES_BANDEJAS,
  AUTORIZACIONES_PRESUPUESTOS_ESTADOS,
} from "../../../utils/constants";
//import BuscadorPractica from "../../turnos/coseguros/BuscadorPractica";
import { PresupuestoItem } from "./PresupuestoItem";
import { TableHeadGestionPresupuestos } from "./TableHeadGestionPresupuestos";
import { Search } from "@material-ui/icons";
import AutoCompletePrestadorAut from "../UI/AutoCompletePrestadorAut";
import { traerSeccionales } from "../../../actions/cbos/seccionales";
import ToolbarXLSPDF from "../../compartidos/ToolbarXLSPDF";

const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: -20,
    // width: "100%",
  },
  input: {
    // padding: 10,
    paddingLeft: 10,
    paddingRight: 10
  },
});

const stateInitial = {
  idProfesional: null,
  fechaInicio: null,
  fechaFin: null,
};

let tieneAreaCentroMedico = false;
let tieneAreaAutorizaciones = false;
let arrayEstadosPresupuestos = [];
let arrayBandejas = [];

let esAuditorContratos = false;
let esAuditorPresupuestos = false;

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (orderBy.includes('.')) {
    const split = orderBy.split('.')
    if (split.length === 2) {
      if (!a[split[0]]) {
        return -1;
      }
      if (!b[split[0]]) {
        return 1;
      }
      if (!a[split[0]] || !b[split[0]] || b[split[0]][split[1]] < a[split[0]][split[1]]) {
        return -1;
      }
      if (b[split[0]][split[1]] > a[split[0]][split[1]]) {
        return 1;
      }
    }
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export const GestionPresupuestosHome = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    afiliadoSeleccionado,
    estadoPresupuestos,
    // estadoPresupuestos = AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE?.toString(),
    presupuestos: items,
    presupuestosContadores,
    bandejasDeUsuario = []
  } = useSelector((state) => state.autorizaciones);
  const { areas = [], bandejasAutorizacion = [] } = useSelector(
    (state) => state.auth
  );
  const { items: itemsSeccionales } = useSelector((state) => state.seccionales);

  const [formValues, , , setearValor, , , , , setearVariosValores,] = useForm(stateInitial);
  const [idPresupuesto, setIdPresupuesto] = useState(null);
  //const [codigoPractica, setCodigoPractica] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [redirect, setRedirect] = useState(false);
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [idSeccional, setIdSeccional] = useState(0);
  const [idBandeja, setIdBandeja] = useState(props.fromCompras ? AUTORIZACIONES_BANDEJAS.COMPRAS : 0);

  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");

  const { fechaInicio, fechaFin,
    cuitPrestador = "",
    nombrePrestador = "",
    idPrestador = "",
    idCartillaPrestador = "",
    idEfectorFacturacion = "", } = formValues;

  useEffect(() => {
    dispatch(clearReducer());
    dispatch(cleanPresupuestos());
    dispatch(cleanAfiliadoSeleccionado());
    dispatch(traerSeccionales());
    dispatch(getBandejasPorUsuario());
  }, [dispatch]);

  useEffect(() => {
    arrayEstadosPresupuestos = Object.entries(AUTORIZACIONES_PRESUPUESTOS_ESTADOS);

    console.log("A", arrayEstadosPresupuestos);

    tieneAreaCentroMedico =
      areas.filter((area) => area.idArea === AREAS_USUARIOS.CENTROS_MEDICOS)
        ?.length > 0;

    tieneAreaAutorizaciones =
      areas.filter((area) => area.idArea === AREAS_USUARIOS.AUTORIZACIONES_NACIONAL)
        ?.length > 0;


    if (tieneAreaAutorizaciones) {
      /*
      const esAuditorProfesional =
        bandejasAutorizacion.filter(
          (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.AUDITOR_MEDICO
            || bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.AUDITOR_TRAUMATOLOGICO
            || bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.AUDITOR_ONCOLOGICO
            || bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.FISIATRIA
        )?.length > 0;
        */

      esAuditorPresupuestos =
        bandejasAutorizacion.filter(
          (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.AUDITOR_PRESUPUESTOS
        )?.length > 0;

      esAuditorContratos =
        bandejasAutorizacion.filter(
          (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.CONTRATOS
        )?.length > 0;

      const tieneBandejaAuditorPresupuestos = false; // esAuditorPresupuestos || esAuditorProfesional;
      const tieneBandejaPendienteContratos = esAuditorContratos /*|| esAuditorProfesional*/; //Los medicos no debe ver Pendiente Contratos
      const mostrarBandejaPendiente =
        bandejasAutorizacion.filter(
          (bandeja) => bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.CONTRATOS &&
            bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITOR_PRESUPUESTOS
        )?.length > 0;
      //const tieneBandejaDevolucion = !esAuditorContratos && !esAuditorPresupuestos;

      arrayEstadosPresupuestos = arrayEstadosPresupuestos.filter(
        (estadoPresupuesto) =>
          (tieneBandejaAuditorPresupuestos &&
            estadoPresupuesto[1] ===
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUDITORIA) ||
          (tieneBandejaPendienteContratos &&
            estadoPresupuesto[1] ===
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS) ||
          (mostrarBandejaPendiente &&
            estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE) ||
          estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO ||
          estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO ||
          estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION ||
          estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA
      );
    }/* else{
      arrayEstadosPresupuestos = arrayEstadosPresupuestos.filter(s => s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA && 
        s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO && s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS);
    } */

    /*  SE ESTA DISPARANDO A PENDIENTE AUNQ SELECCIONE CARGA  
    if (arrayEstadosPresupuestos.filter(s => s[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE ||
      s[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA
    ).length > 0) {
      if (!esAuditorPresupuestos && !esAuditorContratos) {
        dispatch(setEstadoPresupuestos(AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA?.toString()));
      } else {
        dispatch(setEstadoPresupuestos(AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE?.toString()));
      }
    }
    */

    arrayEstadosPresupuestos = arrayEstadosPresupuestos.filter(
      (estadoPresupuesto) => estadoPresupuesto[1] !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.COMPRAS
    );
    arrayEstadosPresupuestos = arrayEstadosPresupuestos.filter(
      (estadoPresupuesto) => estadoPresupuesto[1] !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO_POR_COMPRAS
    );

    if (props.fromCompras) {
      arrayEstadosPresupuestos = arrayEstadosPresupuestos.filter(
        (estadoPresupuesto) => estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
          || estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO
          || estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
          || estadoPresupuesto[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION
      );

      arrayBandejas =
        bandejasDeUsuario.filter(
          (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.COMPRAS
        );
    } else {
      arrayBandejas = bandejasDeUsuario;
    }


    if (arrayEstadosPresupuestos.filter(s => s[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE ||
      s[1] === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA
    ).length > 0)
      dispatch(setEstadoPresupuestos(AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE?.toString()));

  }, [areas, bandejasAutorizacion]);

  console.log("arrayEstadosPresupuestos", arrayEstadosPresupuestos);

  useEffect(() => {
    if (arrayEstadosPresupuestos.filter(s => s[1] === parseInt(estadoPresupuestos)).length > 0) {
      dispatch(
        getPresupuestosGestion(
          afiliadoSeleccionado?.id_afiliado,
          idPresupuesto,
          fechaInicio,
          fechaFin,
          parseInt(estadoPresupuestos),
          idSeccional,
          props.fromCompras ? (parseInt(estadoPresupuestos) === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE ? AUTORIZACIONES_BANDEJAS.COMPRAS : 0) : idBandeja,
          idPrestador,
          idCartillaPrestador,
          idEfectorFacturacion
        )
      );
      setPage(0);
    }
  }, [
    /*dispatch,*/
    afiliadoSeleccionado?.id_afiliado,
    fechaInicio,
    fechaFin,
    estadoPresupuestos,
    idSeccional,
    idPrestador,
    idBandeja
  ]);

  useEffect(() => {
    dispatch(
      getContadoresPresupuestosGestion(
        afiliadoSeleccionado?.id_afiliado,
        idPresupuesto,
        fechaInicio,
        fechaFin,
        estadoPresupuestos,
        idSeccional,
        props.fromCompras ? AUTORIZACIONES_BANDEJAS.COMPRAS : idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion)
    );
  }, [
    dispatch,
    afiliadoSeleccionado?.id_afiliado,
    fechaInicio,
    fechaFin,
    estadoPresupuestos,
    idSeccional,
    idPrestador,
    idBandeja
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };


  const buscarConParametros = (page, pageSize, buscarContadores) => {
    if (arrayEstadosPresupuestos.filter(s => s[1] === parseInt(estadoPresupuestos)).length > 0) {
      dispatch(
        getPresupuestosGestion(
          afiliadoSeleccionado?.id_afiliado,
          idPresupuesto,
          fechaInicio,
          fechaFin,
          parseInt(estadoPresupuestos)
        )
      );
      setPage(0);
    }

    dispatch(
      getContadoresPresupuestosGestion(
        afiliadoSeleccionado?.id_afiliado,
        idPresupuesto,
        fechaInicio,
        fechaFin,
        estadoPresupuestos)
    );

  };

  const handleExportExcel = () => {
    dispatch(
      generateExcelConsultaPresupuesto(
        afiliadoSeleccionado?.id_afiliado,
        idPresupuesto,
        fechaInicio,
        fechaFin,
        parseInt(estadoPresupuestos),
        idSeccional,
        props.fromCompras ? (parseInt(estadoPresupuestos) === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE ? AUTORIZACIONES_BANDEJAS.COMPRAS : 0) : idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion
      )
    );
  };

  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={6}>
            <AutorizacionesBuscador hideTitle={true} />
          </Grid>
          {/*<Grid item xs={12} md={3}>
            <Grid
              container
              spacing={3}
              style={{ display: "flex", padding: 5 }}
            >
              <Grid item xs={12} md={12} >
                <BuscadorPractica
                  cod={codigoPractica}
                  label="Código Practica"
                  gestionAutorizacion={true}
                  setCod={(val) => setCodigoPractica(val)}
                />
              </Grid>
            </Grid>
          </Grid>
          */}
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                // InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                type='number'
                label="N° Presupuesto"
                name="idPresupuesto"
                value={idPresupuesto}
                autoComplete="off"
                //disabled={radioGroupDisabled}
                onChange={(e) => {
                  if (e.target.value === '' || e.target.value > 0) setIdPresupuesto(e.target.value)
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') buscarConParametros() }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscarConParametros}
                      //disabled={radioGroupDisabled}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Inicio"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Fin"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                  onChange={(date) => {
                    setearValor("fechaFin", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={2} /*style={{ marginTop: -5 }}*/>
        <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <FormControl fullWidth>
            <InputLabel>Bandeja</InputLabel>
            <Select
              fullWidth
              id="idBandeja"
              value={idBandeja}
              label="Bandeja"
              //disabled={radioGroupDisabled}
              onChange={(e) => setIdBandeja(e.target.value)}
            >
              {!props.fromCompras && <MenuItem
                key={0}
                value={0}
              >
                Todas
              </MenuItem>}
              {arrayBandejas?.length > 0 &&
                arrayBandejas.map((bandeja) => (
                  <MenuItem
                    key={bandeja.idBandeja}
                    value={bandeja.idBandeja}
                  >
                    {bandeja.descripcion}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
      </Grid>
      <Grid item xs={12} md={2} /*style={{ marginTop: -5 }}*/>
        <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <FormControl fullWidth>
            <InputLabel>Seccional</InputLabel>
            <Select
              fullWidth
              id="idSeccional"
              value={idSeccional}
              label="Seccional"
              //disabled={radioGroupDisabled}
              onChange={(e) => setIdSeccional(e.target.value)}
            >
              <MenuItem
                key={0}
                value={0}
              >
                Todas
              </MenuItem>
              {itemsSeccionales?.length > 0 &&
                itemsSeccionales.map((seccional) => (
                  <MenuItem
                    key={seccional.id_seccional}
                    value={seccional.id_seccional}
                  >
                    {seccional.descripcion_seccional.substr(0, 18)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
      </Grid>
      <Grid item xs={12} md={3} /*style={{ marginTop: -5 }}*/>
        <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <AutoCompletePrestadorAut
            autoCompleteValue={
              {
                prestadorCuit: cuitPrestador,
                prestadorNombreApellido: nombrePrestador,
                efectorFacturacionRazonSocial: "",
                efectorFacturacionCuit: "",
              }
            }
            onChangeHandler={(value) => {
              console.log(value);
              if (value) {
                setearVariosValores({
                  cuitPrestador: value.prestadorCuit,
                  nombrePrestador: value.prestadorNombreApellido,
                  idPrestador: value.idPrestador,
                  idCartillaPrestador: value.idCartillaPrestador,
                  idEfectorFacturacion: value.idEfectorFacturacion
                });
              } else {
                setearVariosValores({
                  cuitPrestador: '',
                  nombrePrestador: '',
                  idPrestador: '',
                  idCartillaPrestador: '',
                  idEfectorFacturacion: '',
                });
              }
            }}
            //disabled={radioGroupDisabled}
            gestionAuditoria={false}
          />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper
          style={{ paddingLeft: 0, textAlign: 'center' }}
          component={"div"}
          elevation={1}
        >
          <Typography
            style={{
              color: "#000000",
              fontSize: "1rem",
              fontWeight: 'bold'
            }}
            variant={"subtitle1"}
            component={"p"}
          >
            Estados
          </Typography>
        </Paper>
        <Paper style={{ padding: "0.25rem" }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoPresupuestos}
            onChange={(e) => {
              dispatch(setEstadoPresupuestos(e.target.value));
            }}
          >
            {arrayEstadosPresupuestos.map((estadoPresupuesto) => {
              const contador = presupuestosContadores.find(s => s.idEstado === estadoPresupuesto[1]);
              const label =
                estadoPresupuesto[0].charAt(0) +
                estadoPresupuesto[0].replace("_", " ").toLowerCase().slice(1) +
                ((contador && contador !== undefined)
                  ?
                  (estadoPresupuesto[1] !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE && props.fromCompras ? `(...)` : `(${contador.total})`)
                  :
                  `(...)`
                );
              return (
                <FormControlLabel
                  key={estadoPresupuesto[1]?.toString()}
                  style={{ marginLeft: "0.5rem" }}
                  label={label}
                  value={estadoPresupuesto[1]?.toString()}
                  control={<Radio />}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHeadGestionPresupuestos
              classes={classes}
              {...{ order, orderBy }}
              onRequestSort={handleRequestSort}
              estadoPresupuestos={parseInt(estadoPresupuestos)}
            />
            <TableBody>
              {items.length > 0 ? (
                // items
                stableSort(items, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <PresupuestoItem
                      item={item}
                      setRedirect={setRedirect}
                      key={item.idPresupuesto?.toString()}
                      esAuditorContratos={esAuditorContratos}
                      estadoPresupuestos={estadoPresupuestos}
                      tieneAreaCentroMedico={tieneAreaCentroMedico}
                      esAuditorPresupuestos={esAuditorPresupuestos}
                      tieneAreaAutorizaciones={tieneAreaAutorizaciones}
                      // expandirPracticas={
                      //   parseInt(estadoPresupuestos) ===
                      //   AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE
                      // }
                      expandirPracticas={false}
                      filtros={
                        {
                          idAfiliado: afiliadoSeleccionado?.id_afiliado,
                          idPresupuesto: idPresupuesto,
                          fechaInicio: fechaInicio,
                          fechaFin: fechaFin,
                          idEstadoPresupuesto: estadoPresupuestos ? parseInt(estadoPresupuestos) : null,
                        }
                      }
                      fromCompras={props.fromCompras}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {items?.length > 0 &&
        <Grid item xs={12} style={{ marginTop: -50 }}>
          <Grid item container justifyContent='center'>
            <Grid item xs={6}>
              <ToolbarXLSPDF
                paper={true}
                handleExportExcel={() => handleExportExcel()}
                iconVerde={true}
              />
            </Grid>
          </Grid>
        </Grid>}
      {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/gestion'
            },
          }}
        />
      )}
    </Grid>
  );
};
